import { gql } from '@apollo/client';
import { PaymentSource } from '../../constants';
import { ORDER_SUMMARY_FRAGMENT } from '../useOrderSummary';
import { UpdateOrderAction } from '../useUpdateOrder';

export type PlaceAffirmSecondPaymentOrderMutationInput = {
  country_code: string;
  id: string;
  data: {
    id: string;
    type: 'orders';
    action_type: UpdateOrderAction;
    attributes: {
      country_code: string;
      payment_source: PaymentSource.Affirm;
      shipment_method: number;
      payment_summary: {
        encrypted_card_data: {
          encrypted_data: string;
        };
        affirm_checkout_token: string;
        billing_address: {
          address_line1: string;
          address_line2: string;
          city: string;
          state: string;
          country_code: string;
          postal_code: string;
        };
      };
    };
  };
};

export type PlaceAffirmSecondPaymentOrderMutationVariables = {
  orderId: string;
  input: PlaceAffirmSecondPaymentOrderMutationInput;
};

export type Order = {
  __typename: 'RestOrder';
  attributes: {
    __typename: 'RestOrderAttributes';
    orderNumber: string;
  };
};

export type PlaceAffirmSecondPaymentOrderMutation = {
  chargeOrder: {
    data: Order[];
  };
};

export const PLACE_AFFIRM_SECOND_PAYMENT_ORDER_MUTATION = gql`
  mutation PlaceAffirmSecondPaymentOrderMutation(
    $orderId: String!
    $input: PlaceAffirmSecondPaymentOrderMutationVariables!
  ) {
    chargeOrder(orderId: $orderId, input: $input)
      @rest(
        type: "UpdateOrderPayload"
        endpoint: "cart"
        path: "/v3.5/orders/{args.orderId}"
        method: "PATCH"
      ) {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
`;
